import { format } from "date-fns";
import { buildPaymentUrl } from "@/features/payment-pages/utils/pay-url";
import type { CopyCohort } from "../services/copy-tags-api";

// Date and time — two releases on one day are two cohorts.
const when = (iso: string) => format(new Date(iso), "dd MMM yyyy, h:mm a");

// "Cohort 2 · from 08 Oct 2026, 11:42 AM"; Cohort 1 is everyone before the
// first release.
export function cohortLabel(c: CopyCohort, all: CopyCohort[]): string {
  if (c.from) return `${c.label} · from ${when(c.from)}`;
  const next = all[1]?.from;
  return next
    ? `${c.label} · joined before ${when(next)}`
    : `${c.label} · all customers`;
}

// The cohort to show: the one already picked while it still exists, else the
// newest — what a customer joining today reads. Null while none are loaded.
export function pickCohortAsOf(
  cohorts: CopyCohort[],
  current: string | null,
): string | null {
  if (!cohorts.length) return null;
  if (current && cohorts.some((c) => c.asOf === current)) return current;
  return cohorts[cohorts.length - 1].asOf;
}

// The saved page as a customer in that cohort sees it.
export function livePageUrl(slug: string, asOf: string): string {
  return `${buildPaymentUrl(slug)}?as_of=${encodeURIComponent(asOf)}`;
}

// Every string in the copy, in order — the sentences a customer reads.
export function renderLines(value: unknown): string[] {
  if (typeof value === "string") return value ? [value] : [];
  if (Array.isArray(value)) return value.flatMap(renderLines);
  if (value && typeof value === "object") {
    return Object.values(value).flatMap(renderLines);
  }
  return [];
}
